<template>
  <component
    :is="tag"
    class="c-button"
    :class="[
      {
        'c-button--loading': loading,
        'c-button--disabled': disabled,
        'c-button--block': block
      },
      `c-button--${type}`
    ]"
    @click="onClick"
  >
    <span
      v-if="loading"
      class="c-button-loading__spinner"
    />
    <slot v-else />
  </component>
</template>

<script setup>
const props = defineProps({
  tag: {
    type: String,
    default: 'button'
  },
  type: {
    type: String,
    default: 'default'
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  block: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['click'])

const onClick = (event) => {
  if (props.loading) {
    event.preventDefault()
  } else if (!props.disabled) {
    emit('click', event)
  }
}
</script>

<style lang="less">
.c-button {
  position: relative;
  height: 44px;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  font-family: mon-600;
  font-size: 14px;
  transition: all .2s;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  -webkit-tap-highlight-color: transparent;

  &:not(&--disabled):not(&--loading):active {
    filter: brightness(80%);
  }

  @media (hover: hover) {
    &:not(&--disabled):not(&--loading):hover {
      filter: brightness(80%);
    }
  }

  &--default {
    border: 1px solid #EBF1F5;
    color: #232323;
    background: #FFF;
  }

  &--primary {
    color: #FFFFFF;
    background: rgba(5, 39, 132, 1);
  }

  &--secondary {
    color: #FFFFFF;
    background: rgba(70, 129, 249, 1);
  }

  &--text {
    background: transparent;
    font-family: mon-500;

    @media (hover: hover) {
      &:hover {
        opacity: 60%;
      }
    }
  }

  &--block {
    display: flex;
    width: 100%;
  }

  &--disabled {
    opacity: .6;
    cursor: not-allowed;
  }

  &--loading {
    cursor: not-allowed;
  }

  &-loading {
    &__spinner {
      display: inline-block;
      width: 1.3em;
      height: 1.3em;
      border: 2px solid;
      border-top: 2px solid transparent;
      border-radius: 50%;
      animation: spinner 1s linear infinite;
    }
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
